<template>
  <div class="container">
    <div class="export-container">
      <button class="export-button" id="toEXCEL" @click="exportToExcel">
        تحميل ملف Exel
      </button>
    </div>
    <div class="table" id="customers_table">
      <div class="table__body">
        <table>
          <thead>
            <tr>
              <th>رقم الفيديو</th>
              <th>اسم الفيديو</th>
              <th>عدد الأسئلة</th>
              <th>النتيجة</th>
              <th>عدد الأسئلة المحلولة</th>
              <th>عدد الأسئلة الصحيحة</th>
              <th>الإجابات</th>
              <th>وقت انتهاء الكويز</th>
              <th>وقت بدأ الكويز</th>
              <th>رقم الكويز</th>
              <th>وقت إنشاء الكويز</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1062787</td>
              <td>كويز على المحاضره الاولى ـ الباب الثاني</td>
              <td>10</td>
              <td>60%</td>
              <td>10</td>
              <td>6</td>
              <td class="answers">
                <span class="available">عرض الإجابات</span>
              </td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>PDOQ42NKAX</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
            </tr>
            <tr>
              <td>1062787</td>
              <td>كويز على المحاضره الاولى ـ الباب الثاني</td>
              <td>10</td>
              <td>60%</td>
              <td>10</td>
              <td>6</td>
              <td class="answers">
                <span class="unavailable">الإجابات غير متاحة</span>
              </td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>PDOQ42NKAX</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
            </tr>
            <tr>
              <td>1062787</td>
              <td>كويز على المحاضره الاولى ـ الباب الثاني</td>
              <td>10</td>
              <td>60%</td>
              <td>10</td>
              <td>6</td>
              <td class="answers">
                <span class="available">عرض الإجابات</span>
              </td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>PDOQ42NKAX</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
            </tr>
            <tr>
              <td>1062787</td>
              <td>كويز على المحاضره الاولى ـ الباب الثاني</td>
              <td>10</td>
              <td>60%</td>
              <td>10</td>
              <td>6</td>
              <td class="answers">
                <span class="available">عرض الإجابات</span>
              </td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
              <td>PDOQ42NKAX</td>
              <td>الثلاثاء، ١٣ أغسطس ٢٠٢٤</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import exportToExcel from "../../../services/csv";
export default {
  name: "VideoQuizResultsComponent",
  components: {},
  data() {
    return {};
  },
  methods: {
    exportToExcel() {
      exportToExcel();
    },
  },
};
</script>

<style scoped>
.export-container {
  text-align: center;
  margin-bottom: 2rem;
}
.export-button {
  background-color: #fff;
  color: #000;
  box-shadow: 0px 0px 2px 0px #000000;
  padding: 1rem 2rem;
  border-radius: 30px;
  cursor: pointer;
  border: none;
  outline: none;
  font-size: 1rem;
  transition: all 0.3s;
}
.export-button:hover {
  background-color: #038c4c;
  color: #fff;
}
.table > :not(caption) > * > * {
  background-color: transparent;
}
.table {
  position: relative;
  width: 100%;
  height: 75vh;
  background-color: #fff;
  box-shadow: 0 0.4rem 0.8rem #0005;
  border-radius: 1.25rem;
  overflow: hidden;
  padding: 2rem;
  direction: ltr;
}
.table__body {
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 1.25rem;
  padding: 0 2rem 2rem 2rem;
  overflow: auto;
  overflow: overlay;
}
.table__body::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}
.table__body::-webkit-scrollbar-thumb {
  border-radius: 0.5rem;
  background-color: #c3c3c3;
  border: 1px solid #c3c3c3;
}
.table__body::-webkit-scrollbar-track {
  background-color: #eeeeee;
}
table {
  width: 100%;
  direction: rtl;
}
table,
th,
td {
  border-collapse: collapse;
  padding: 1rem 0.5rem;
  text-align: center;
  min-width: 190px;
  min-height: 31px;
}
thead th {
  position: sticky;
  top: 0;
  /* left: 0; */
  z-index: 1;
  background-color: #fff;
  color: #000;
  border: none;
  border-bottom: 0.1rem solid #00000020;
}
tbody tr {
  background-color: #fff;
  border: none;
  border-bottom: 0.1rem solid #00000010;
}
th {
  color: #000;
  font-weight: 700;
}

td {
  color: #000000;
  font-weight: 500;
}
.unavailable,
.available {
  padding: 0.5rem 2rem;
  border-radius: 2rem;
  width: 100%;
  display: inline-block;
  color: #fff !important;
}
.available {
  background-color: #2abf7a;
}
.unavailable {
  background-color: #e71c39;
}
/* Dark Mode */
body.dark .header,
body.dark th,
body.dark .header .num-logout-day .title,
body.dark .header .num-logout-week .title,
body.dark .header .num-logout-auto .title {
  color: #fff;
}
body.dark .header .num-logout-day .count,
body.dark .header .num-logout-week .count,
body.dark .header .num-logout-auto .count {
  background-color: #13323a;
  color: #fff;
}
body.dark .export-button {
  background-color: #1d4955;
  color: #fff;
}
body.dark .export-button:hover {
  background-color: #038c4c;
}
body.dark .table__body::-webkit-scrollbar-thumb {
  background-color: #235562;
  border: 1px solid #13323a;
}
body.dark .table__body::-webkit-scrollbar-track {
  background-color: #13323a;
}
body.dark .header,
body.dark tbody tr,
body.dark .table__body,
body.dark .table {
  background-color: #1d4955;
}
body.dark thead th {
  background-color: #1d4955;
  color: #fff;
  border: none;
  border-bottom: 0.1rem solid #ffffff20;
}
body.dark td {
  color: #ffffff;
}
body.dark .unavailable,
body.dark .available {
  color: #1d4955 !important;
}
body.dark .available {
  background-color: #31d287;
}
body.dark .unavailable {
  background-color: #e9334e;
}
/*  Media queries */
@media screen and (max-width: 1200px) {
  .header {
    width: 100%;
    flex-direction: column;
    gap: 1rem;
  }
  .header .num-logout-day,
  .header .num-logout-week,
  .header .num-logout-auto {
    min-width: 100%;
    align-items: center;
    justify-content: space-between;
  }
}
@media screen and (max-width: 992px) {
  .header .num-logout-day .count,
  .header .num-logout-week .count,
  .header .num-logout-auto .count {
    font-size: 1rem;
    padding: 1rem;
  }
  .export-button {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }
  .table {
    padding: 1rem;
  }
  .table__body {
    padding: 0 1rem 1rem 1rem;
  }
  .header .num-logout-day .title,
  .header .num-logout-week .title,
  .header .num-logout-auto .title {
    font-size: 0.8rem;
  }
  th,
  td {
    font-size: 0.9rem;
  }
}
</style>
